export class BelegPositionInlineResult {
    positionen: any[] = []; // AbgabebelegPosition
    insertChargen = false;
}
